<template>
  <div>
    <div class="enquiry-container">
      <div class="flex-wrap enquiry-box" v-if="adClicks > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo ad-click-logo">&nbsp;</span>Ad Clicks
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ adClicks.toLocaleString() }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Total number of clicks on your ads.
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="socialAds > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo social-logo">&nbsp;</span>Social Ad Engagement
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ socialAds.toLocaleString() }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Total number of times the social ads were liked, shared or commented on.
        </div>
      </div>
      <!-- <div class="flex-wrap enquiry-box" v-if="totalEnquiry > 0">
				<div class="enquiry-logo-title flex-centered"><span class="enquiry-logo enquiries-logo">&nbsp;</span>Total Enquiry</div>
				<div class="enquiry-logo-value flex-centered">
					{{ totalEnquiry.toLocaleString() }}
				</div>
				<div class="enquiry-logo-tooltip flex-centered">
					The number of enquiries made via phone, online, or the website
				</div>
			</div> -->
      <div class="flex-wrap enquiry-box" v-if="totalEnquiry > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo social-enquiries-logo">&nbsp;</span>Enquiry via Social
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ Number(this.campaign.stats.conversions.SocialFormLeads || 0) }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Buyer enquires submitted from Facebook & Instagram
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="this.campaign.stats.conversions.EmailClick > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo email-enquiries-logo">&nbsp;</span>Enquiry via Email
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ Number(this.campaign.stats.conversions.EmailClick || 0) }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Buyer enquiry submitted via email
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="this.campaign.stats.conversions.ClickToCall > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo phone-enquiries-logo">&nbsp;</span>Enquiry via Phone
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ Number(this.campaign.stats.conversions.ClickToCall || 0) }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Buyer enquiry made via clicking to call
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="this.campaign.stats.conversions.enquireForm > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo form-enquiries-logo">&nbsp;</span>Enquiry via Form
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ Number(this.campaign.stats.conversions.enquireForm || 0) }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Buyer enquiry made via website form submission
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="propertyReport > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo enquiries-logo">&nbsp;</span>Report Requests
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ propertyReport.toLocaleString() }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          The number of property report requests completed
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="this.campaign.stats.conversions.InitChat > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo ai-enquiries-logo">&nbsp;</span>Website Live Chat
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ Number(this.campaign.stats.conversions.InitChat || 0) }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Buyer engagement via live chat with GaiLE virtual property
        </div>
      </div>
    </div>
    <div class="flex-centered enquiry-heading">
      Additional Interest on Current Listings
    </div>
    <div class="enquiry-container">
      <div class="flex-wrap enquiry-box" v-if="SOIPriceEnquiry > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo soi-logo">&nbsp;</span>SOI Views
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ SOIPriceEnquiry.toLocaleString() }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Total number of SOI views.
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="floorplanViews > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo floorplan-logo">&nbsp;</span>Floorplan Views
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ floorplanViews.toLocaleString() }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Total number of times the floorplan was viewed.
        </div>
      </div>
      <div class="flex-wrap enquiry-box" v-if="photoVideoViews > 0">
        <div class="enquiry-logo-title flex-centered">
          <span class="enquiry-logo photo-video-logo">&nbsp;</span>Image Views
        </div>
        <div class="enquiry-logo-value flex-centered">
          {{ photoVideoViews.toLocaleString() }}
        </div>
        <div class="enquiry-logo-tooltip flex-centered">
          Total number of times listing imagery was viewed across all media channels.
        </div>
      </div>
    </div>
    <div class="conditions-text">
      <p>
        Campaign metrics demonstrate the awareness generated with potential vendors within
        your target markets. <br />
        A consistent online presence helps build your brand and your new listing
        opportunities.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["campaign"],
  data() {
    return {
      propertyReport: this.getPropertyReport(),
      adClicks: this.getAdClicks(),
      socialAds: this.getSocialAds(),
      totalEnquiry: this.getTotalEnquiry(),
      SOIPriceEnquiry: this.getSOIPriceEnquiry(),
      floorplanViews: this.getFloorplanViews(),
      photoVideoViews: this.getPhotoVideoViews(),
    };
  },
  methods: {
    getPropertyReport() {
      return this.campaign.stats && this.campaign.stats.conversions.PropertyReport
        ? Number(this.campaign.stats.conversions.PropertyReport || 0)
        : 0;
    },
    getAdClicks() {
      return this.campaign.stats && this.campaign.stats.clicks
        ? Number(this.campaign.stats.clicks)
        : 0;
    },
    getSocialAds() {
      return this.campaign.stats && this.campaign.stats.conversions.socialEngagement
        ? Number(this.campaign.stats.conversions.socialEngagement)
        : 0;
    },
    getTotalEnquiry() {
      if (!this.campaign.stats) return 0;
      return Number(
        (this.campaign.stats.conversions.enquireForm || 0) +
          (this.campaign.stats.conversions.EmailClick || 0) +
          (this.campaign.stats.conversions.SocialFormLeads || 0) +
          (this.campaign.stats.conversions.AgentEmail || 0) +
          (this.campaign.stats.conversions.agentPageEnquiry || 0) +
          (this.campaign.stats.conversions.ClickToCall || 0) +
          (this.campaign.stats.conversions.PhoneNumberClick || 0) +
          (this.campaign.stats.conversions.agentPageMobile || 0) +
          (this.campaign.stats.conversions.AgentCall || 0) +
          (this.campaign.stats.conversions.PropertyReport || 0)
      );
    },
    getSOIPriceEnquiry() {
      if (!this.campaign.stats) return 0;
      return Number(
        (this.campaign.stats.conversions.ListingSoi || 0) +
          (this.campaign.stats.conversions.SOI || 0) +
          (this.campaign.stats.conversions["SOI-Download"] || 0)
      );
    },
    getFloorplanViews() {
      if (!this.campaign.stats) return 0;
      return Number(
        (this.campaign.stats.conversions.FloorplanbtnClick || 0) +
          (this.campaign.stats.conversions.ListingFloorplan || 0) +
          (this.campaign.stats.conversions.ViewFloorplan || 0)
      );
    },
    getPhotoVideoViews() {
      if (!this.campaign.stats) return 0;
      return Number(
        (this.campaign.stats.conversions.ImageCarouselClick || 0) +
          (this.campaign.stats.conversions.ViewGallery || 0) +
          (this.campaign.stats.conversions.ListingVideo || 0) +
          (this.campaign.stats.conversions.videoViews || 0) +
          (this.campaign.stats.conversions.ViewVideo || 0)
      );
    },
  },
};
</script>
